var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SingleSelectInput.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7bf8c318\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SingleSelectInput.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShopperManagement/FormComponents/SingleSelectInput.vue
// module id = 1609
// module chunks = 1